import {
  List,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import * as React from "react";
import { useLanguage } from "../../Language";
import { TextualHolding } from "../../../dto/TextualHolding";
import { useIsMobile } from "@tlc/ui/useIsMobile";
export interface TextualHoldingsProps {
  holdings: TextualHolding[];
}
export const TextualHoldings: React.FC<TextualHoldingsProps> = ({
  holdings,
}) => {
  const { translate } = useLanguage();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <List>
        {holdings.map((textualHolding) => (
          <ListItem
            divider
            key={textualHolding.id}
            disablePadding
            disableGutters
          >
            <ListItemText
              primary={textualHolding.textualHoldingStatement}
              secondary={textualHolding.publicNote}
            />
          </ListItem>
        ))}
      </List>
    );
  }
  return (
    <Table component="table" style={{ marginBottom: 20 }}>
      <TableHead component="thead">
        <TableRow component="tr">
          <TableCell component="th">{translate("holdingStatement")}</TableCell>
          <TableCell component="th">{translate("publicNote")}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody component="tbody">
        {holdings.map((textualHolding) => (
          <TableRow component="tr">
            <TableCell component="td">
              {textualHolding.textualHoldingStatement}
            </TableCell>
            <TableCell component="td">{textualHolding.publicNote}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
